import { AuthProviers } from "@/contexts/auth-context/auth-types";
import { getJWTLocalStorage } from "@/utils/local-storage/user/local-storage";
import { OAuthExtension } from "@magic-ext/oauth";
//@ts-expect-error error de magic-sdk (update dependency for audit and 0 risk)
import { Magic } from 'magic-sdk';

const magic = new Magic(import.meta.env.VITE_MAGIC_API_KEY, {
    extensions: [new OAuthExtension()],
});

export const logoutMagic = async () => {
    await magic.user.logout();
}

export const loginEmailMagicLink = async(email: string) => {
    const magic_token = await magic.auth.loginWithMagicLink({ email });
    const userInfo = await magic.user.getMetadata();
    if (!userInfo.publicAddress) {
        throw new Error("No public address found")
    }
    if (!magic_token) {
        throw new Error("No magic token found")
    }
    return { userInfo, magic_token }
}

export const loginSocialMagic = async (provider: AuthProviers) => {
    await magic.oauth.loginWithRedirect({
        provider,
        redirectURI: `${window.location.origin}/login`
    });
}

export const isLoggedInMagic = async() => {
    const isLoggedIn = await magic.user.isLoggedIn();
    if (!isLoggedIn) {
        throw new Error("User not login")
    }
    const magic_token = await magic.user.getIdToken();
    const userInfo = await magic.user.getMetadata();
    if (!userInfo.publicAddress) {
        throw new Error("No public address found")
    }
    if (!magic_token) {
        throw new Error("No magic token found")
    }
    return { userInfo, magic_token }
}

export const redirectLoginMagic = async () => {
    const existJWT = getJWTLocalStorage();
    if(!existJWT) {
        await magic.oauth.getRedirectResult();
    }
}
